import { render, staticRenderFns } from "./NewsNotification.vue?vue&type=template&id=adbfb4fe&scoped=true&"
import script from "./NewsNotification.vue?vue&type=script&lang=js&"
export * from "./NewsNotification.vue?vue&type=script&lang=js&"
import style0 from "./NewsNotification.vue?vue&type=style&index=0&id=adbfb4fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adbfb4fe",
  null
  
)

export default component.exports